import React from 'react'
import { useSelector } from 'react-redux';
import { CODEMP_MUSIMUNDO } from '../utilities';

const IntentionNum = ({codpmpol}) => {

  const { codemp } = useSelector(state => state.adminReducer.login);

  return (
    <div style={{ display:'flex', flexDirection:'row', justifyContent:'center'}}>
        <strong>
          <p style={{color: CODEMP_MUSIMUNDO.includes(codemp) ? 'red' : 'blue'}}>ID:</p>
        </strong>
        <p style={{color:'rgba(62, 62, 62, 1)'}}>{codpmpol}</p>
    </div>
  )
}

export default IntentionNum
